module.exports = __webpack_public_path__ + "img/essenza.bb761399.png";